import { Stack } from '@mui/material'
import Box from '@mui/material/Box/Box'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BreadCrumbsGroup from 'ui/breadCrumbs/BreadCrumbsGroup'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchRations } from '../../store/rationSystemSlice'
import { COLORS } from '../../styles/colors'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'
import RationCard from './RationCard'

export const BREADCRUMBS_OPTIONS = [
	{ id: 'active', title: 'Активный' },
	{ id: 'archived', title: 'Неактивный' },
]

const RationsFullCards = () => {
	const [activeFilter, setActiveFilter] = useState<string>('all')
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	useEffect(() => {
		dispatch(fetchRations())
	}, [])
	const { rationArray, loading, error } = useAppSelector(
		state => state.rationSystemReducer,
	)
	const { userData } = useAppSelector(state => state.userReducer)
	const permissions = useAppSelector(state => state.authReducer.permissions)
	const activeRation = rationArray?.filter(el => el.is_archived === false)
	const archivedRation = rationArray?.filter(el => el.is_archived === true)
	if (loading) {
		return (
			<Box
				sx={{
					marginTop: '25%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<CircularProgress
					sx={{
						'&.MuiCircularProgress-colorPrimary': { color: COLORS.main },
					}}
				/>
			</Box>
		)
	} else if (error) {
		;<>{error}</>
	}

	let sortedArray = []

	if (activeFilter === 'all') {
		sortedArray = rationArray ? [...rationArray] : []

		sortedArray.sort((a, b) => {
			if (a.is_archived === b.is_archived) {
				return 0
			}
			return a.is_archived ? 1 : -1
		})
	}

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
				}}
			>
				<BreadCrumbsGroup
					allLabel='Все'
					handleActiveFilter={id => setActiveFilter(String(id))}
					array={BREADCRUMBS_OPTIONS.map(option => ({
						...option,
						selected: activeFilter === option.id,
					}))}
				/>
			</Box>
			<TypographySecondary sx={{ marginTop: '8px', marginBottom: '16px' }}>
				Всего рационов:{' '}
				{activeFilter === 'active'
					? activeRation.length
					: activeFilter === 'archived'
						? archivedRation.length
						: rationArray?.length}
			</TypographySecondary>
			<Stack direction='column' gap='16px'>
				{activeFilter === 'all' &&
					sortedArray?.map(el => <RationCard key={el.id} rationArray={el} />)}
				{activeFilter === 'active' &&
					activeRation.map(el => <RationCard key={el.id} rationArray={el} />)}
				{activeFilter === 'archived' &&
					archivedRation.map(el => <RationCard key={el.id} rationArray={el} />)}
			</Stack>
		</Box>
	)
}

export default RationsFullCards
